export const isRootUser = () => {
  return window.location.pathname.includes('/admin');
};
